import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { Card } from '@veneer/core';
const { color, typography } = primitives;

export const DetailsCard = styled(Card)`
  && {
    max-width: 526px;
    padding: 24px;
    background-color: ${color.white};
    display: flex;
    gap: 20px;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    border-top: 20px solid ${color.electricBlue2};
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
    }
  }
`;

export const DetailsCardTitleAndSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DetailsCardTitle = styled.div`
  font-weight: ${typography.weight4};
  font-size: ${typography.size5};
  line-height: ${typography.lineHeight3};
  @media (max-width: 768px) {
    font-size: ${typography.size3};
    line-height: ${typography.lineHeight3};
  }
`;

export const DetailsCardSubtitle = styled.div`
  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
`;

export const ImageSection = styled.div`
  display: flex;
  align-items: center;
  width: 80px;
  height: 56px;
`;

export const ItemImage = styled.img`
  width: 55px;
  height: 40px;
`;

export const ItemSection = styled.div`
  display: flex;
  align-items: center;
`;

export const SubscriptionPlanItems = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemTitle = styled.div`
  font-weight: ${typography.weight3};
  font-size: ${typography.size1};
  line-height: ${typography.lineHeight2};
`;

export const PlanNotification = styled.div`
  font-size: ${typography.size1};
  font-weight: ${typography.weight3};
  display: inline-block;
  line-height: ${typography.lineHeight1};
  width: 100%;
  > div {
    width: 100%;
    min-height: 36px;
  }
`;

export const IconNotification = styled.div`
  > svg {
    fill: ${color.electricBlue6};
  }
`;
